import React, { useRef, useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { css } from "@emotion/core";
import Player from "./Player";
import colors from "../../Styles/colors";
import padding from "../../Styles/padding";

let backdrop = css`
  margin-top: -3vw;
  margin-bottom: ${padding.large};
  padding-top: 3vw;
  background: #000;
`;

let heightController = css`
  position: relative;
  width: 100%;
  max-width: 145vh;
  margin: 0 auto;
  overflow: hidden;
`;

let mask = css`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 1;
`;

let loadbar = css`
  position: absolute;
  bottom: 1px;
  left: 0;
  width: 0;
  height: 5px;
  background: ${colors.main};
  animation: expand 1s;

  @keyframes expand {
    to {
      width: 100%;
    }
  }
`;

let reveal = css`
  opacity: 0;
  transition: opacity 500ms;
`;

let remove = css`
  z-index: -100;
`;

function delay(ms) {
  return new Promise((resolve => {
    setTimeout(resolve, ms);
  }));
}

// STATE: 'FETCHING' | 'LOADING' | 'READY' | 'AVAILABLE'

function useTransition(from, to, current, transitionTo, duration) {
  useEffect(() => {
    let cancelled = false;

    if (current === from) {
      delay(duration).then(() => {
        if (!cancelled) {
          transitionTo(to);
        }
      });
    }

    return () => cancelled = true;
  }, [current]);
}

export default function Livestream({ channel, requiresDMA }) {
  let mounted = useRef(false);
  let [display, setDisplay] = useState('LOADING');
  let onFetched = useCallback(() => setDisplay('LOADING'), []);

  useEffect(() => {
    if (mounted.current) {
      setDisplay('FETCHING');
    } else {
      mounted.current = true;
    }
  }, [channel]);

  useTransition('LOADING', 'READY', display, setDisplay, 1000);
  useTransition('READY', 'AVAILABLE', display, setDisplay, 500);

  let maskLayer;

  switch (display) {
    case 'FETCHING':
    case 'LOADING':
      maskLayer = mask;
      break;
    case 'READY':
      maskLayer = [mask, reveal];
      break;
    case 'AVAILABLE':
      maskLayer = [mask, remove];
      break;
  }

  return <div css={backdrop}>
    <div css={heightController}>
      <Player channel={channel} requireDMA={requiresDMA} onFetched={onFetched} />
      <div css={maskLayer} />
      {display === 'LOADING' && <div css={loadbar} />}
    </div>
  </div>;
}